module.exports = __webpack_public_path__ + "img/SquidGame_Unit_101_627.9bbf1181.webp";